import React, { useEffect, useState } from 'react';
import './index.scss';
import { displayAds } from '..';
export default function AdSlot({
  id,
  customStyle,
  className = '',
  enableCloseBtn = false,
  innerDivClassName = '',
  featureDisplayAdsFlag = true,
  displayAdSlot = true
}) {
  const [isVisibleAds, setVisibleAds] = useState(true);
  useEffect(() => {
    displayAdSlot && displayAds(id, featureDisplayAdsFlag);
  }, []);

  return (
    <>
      {featureDisplayAdsFlag && isVisibleAds && (
        <div className={className}>
          <div id={id} style={customStyle} className={innerDivClassName}></div>
          {enableCloseBtn && (
            <button
              id={id + '-closeBtn'}
              className="closeAds"
              onClick={() => setVisibleAds(false)}
            >
              <img
                src="/content/images/icons/closeAds.svg"
                width="18px"
                height="18px"
              />
            </button>
          )}
        </div>
      )}
    </>
  );
}
